// extracted by mini-css-extract-plugin
export default {"actionsView":"styles_actionsView__+RXWH","singleAction":"styles_singleAction__mfu7A","ui-spin":"styles_ui-spin__fjc2j"};